import { Editor } from "grapesjs";
import APIS from "../../../../../constant/Endpoint";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  // const navigationData = await getApiData(APIS.NAVIGATION, {});
  // if (!navigationData || !navigationData.data) {
  //   console.error("Navigation data is not available!");
  //   return;
  // }

  // const navLinks = navigationData.data
  //   .map((link: { path: string; name: string }) => {
  //     return `<a href="${link.path}" class="text-black hover:bg-red-200 px-2 py-1 rounded">${link.name}</a>`;
  //   })
  //   .join("");

  Components.addType("reliable-navbar", {
    isComponent: (el) => {
      if (el.className === "reliable-navbar") {
        return {
          type: "reliable-navbar",
        };
      }
    },
    model: {
      defaults: {
        components: html`
          <nav class="shadow-lg bg-white w-full reliable-navbar relative z-50">
            <div class="hidden md:block w-full py-2 bg-white shadow-sm">
              <div class="container mx-auto  px-4 md:px-12 ">
                <div class="flex items-center justify-between w-full">
                  <div class="flex  items-center justify-center space-x-2">
                    <span class="whitespace-nowrap font-semibold"
                      >Follow us on:</span
                    >
                    <a href="#" class="hover:text-blue-500 text-[#FA6914] p-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 31 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.0002 15.5415C28.0002 8.6415 22.4002 3.0415 15.5002 3.0415C8.6002 3.0415 3.0002 8.6415 3.0002 15.5415C3.0002 21.5915 7.3002 26.629 13.0002 27.7915V19.2915H10.5002V15.5415H13.0002V12.4165C13.0002 10.004 14.9627 8.0415 17.3752 8.0415H20.5002V11.7915H18.0002C17.3127 11.7915 16.7502 12.354 16.7502 13.0415V15.5415H20.5002V19.2915H16.7502V27.979C23.0627 27.354 28.0002 22.029 28.0002 15.5415Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                    <a href="#" class="hover:text-blue-500 text-[#FA6914] p-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 31 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.7854 3.0415C18.1916 3.04525 18.9054 3.05275 19.5216 3.07025L19.7641 3.079C20.0441 3.089 20.3204 3.1015 20.6541 3.1165C21.9841 3.179 22.8916 3.389 23.6879 3.69775C24.5129 4.01525 25.2079 4.44525 25.9029 5.139C26.5387 5.76367 27.0306 6.51959 27.3441 7.354C27.6529 8.15025 27.8629 9.05775 27.9254 10.389C27.9404 10.7215 27.9529 10.9978 27.9629 11.279L27.9704 11.5215C27.9891 12.1365 27.9966 12.8503 27.9991 14.2565L28.0004 15.189V16.8265C28.0034 17.7383 27.9938 18.65 27.9716 19.5615L27.9641 19.804C27.9541 20.0853 27.9416 20.3615 27.9266 20.694C27.8641 22.0253 27.6516 22.9315 27.3441 23.729C27.0306 24.5634 26.5387 25.3193 25.9029 25.944C25.2782 26.5799 24.5223 27.0717 23.6879 27.3853C22.8916 27.694 21.9841 27.904 20.6541 27.9665L19.7641 28.004L19.5216 28.0115C18.9054 28.029 18.1916 28.0378 16.7854 28.0403L15.8529 28.0415H14.2166C13.3045 28.0447 12.3923 28.0351 11.4804 28.0128L11.2379 28.0053C10.9411 27.994 10.6445 27.9811 10.3479 27.9665C9.01788 27.904 8.11038 27.694 7.31288 27.3853C6.47891 27.0716 5.72343 26.5797 5.09913 25.944C4.46281 25.3195 3.97051 24.5635 3.65663 23.729C3.34788 22.9328 3.13788 22.0253 3.07538 20.694L3.03788 19.804L3.03163 19.5615C3.00858 18.65 2.99817 17.7383 3.00038 16.8265V14.2565C2.99692 13.3448 3.00608 12.433 3.02788 11.5215L3.03663 11.279C3.04663 10.9978 3.05913 10.7215 3.07413 10.389C3.13663 9.05775 3.34663 8.1515 3.65538 7.354C3.96999 6.51925 4.46315 5.7633 5.10038 5.139C5.72432 4.50344 6.47936 4.0116 7.31288 3.69775C8.11038 3.389 9.01663 3.179 10.3479 3.1165C10.6804 3.1015 10.9579 3.089 11.2379 3.079L11.4804 3.0715C12.3919 3.04929 13.3036 3.03971 14.2154 3.04275L16.7854 3.0415ZM15.5004 9.2915C13.8428 9.2915 12.2531 9.94998 11.081 11.1221C9.90886 12.2942 9.25038 13.8839 9.25038 15.5415C9.25038 17.1991 9.90886 18.7888 11.081 19.9609C12.2531 21.133 13.8428 21.7915 15.5004 21.7915C17.158 21.7915 18.7477 21.133 19.9198 19.9609C21.0919 18.7888 21.7504 17.1991 21.7504 15.5415C21.7504 13.8839 21.0919 12.2942 19.9198 11.1221C18.7477 9.94998 17.158 9.2915 15.5004 9.2915ZM15.5004 11.7915C15.9928 11.7914 16.4805 11.8883 16.9355 12.0767C17.3905 12.2651 17.8039 12.5413 18.1522 12.8894C18.5005 13.2376 18.7768 13.6509 18.9653 14.1059C19.1538 14.5608 19.2509 15.0484 19.251 15.5409C19.2511 16.0333 19.1542 16.521 18.9658 16.976C18.7774 17.431 18.5013 17.8444 18.1531 18.1927C17.8049 18.541 17.3916 18.8173 16.9366 19.0058C16.4817 19.1943 15.9941 19.2914 15.5016 19.2915C14.5071 19.2915 13.5532 18.8964 12.85 18.1932C12.1467 17.4899 11.7516 16.5361 11.7516 15.5415C11.7516 14.5469 12.1467 13.5931 12.85 12.8899C13.5532 12.1866 14.5071 11.7915 15.5016 11.7915M22.0641 7.4165C21.6497 7.4165 21.2523 7.58112 20.9593 7.87415C20.6662 8.16718 20.5016 8.5646 20.5016 8.979C20.5016 9.3934 20.6662 9.79083 20.9593 10.0839C21.2523 10.3769 21.6497 10.5415 22.0641 10.5415C22.4785 10.5415 22.876 10.3769 23.169 10.0839C23.462 9.79083 23.6266 9.3934 23.6266 8.979C23.6266 8.5646 23.462 8.16718 23.169 7.87415C22.876 7.58112 22.4785 7.4165 22.0641 7.4165Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                    <a href="#" class="hover:text-blue-500 text-[#FA6914] p-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 31 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.575 8.04199C27.6125 8.47949 26.5751 8.76699 25.5 8.90449C26.6 8.24199 27.4501 7.19199 27.8501 5.92949C26.8126 6.55449 25.6625 6.99199 24.4501 7.24199C23.4625 6.16699 22.0751 5.54199 20.5001 5.54199C17.5626 5.54199 15.1625 7.94199 15.1625 10.9045C15.1625 11.3295 15.2126 11.742 15.3001 12.1295C10.85 11.9045 6.88755 9.76699 4.25005 6.52949C3.78755 7.31699 3.52505 8.24199 3.52505 9.21699C3.52505 11.0795 4.46255 12.7295 5.91255 13.667C5.02505 13.667 4.20005 13.417 3.47505 13.042V13.0795C3.47505 15.6795 5.32505 17.8545 7.77505 18.342C6.9886 18.5582 6.1626 18.5881 5.36255 18.4295C5.70206 19.4951 6.36697 20.4275 7.26382 21.0957C8.16067 21.7638 9.24436 22.1341 10.3625 22.1545C8.46714 23.6551 6.11756 24.4662 3.70005 24.4545C3.27505 24.4545 2.85005 24.4295 2.42505 24.3795C4.80005 25.9045 7.62505 26.792 10.65 26.792C20.5001 26.792 25.9126 18.617 25.9126 11.5295C25.9126 11.292 25.9125 11.067 25.9 10.8295C26.9501 10.0795 27.85 9.12949 28.575 8.04199Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                    <a href="#" class="hover:text-blue-500 text-[#FA6914] p-2">
                      <svg
                        fill="currentColor"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        xml:space="preserve"
                      >
                        <path
                          d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 10.692 6.33 6.33 0 0 0 10.857-4.424V8.687a8.182 8.182 0 0 0 4.773 1.526V6.79a4.831 4.831 0 0 1-1.003-.104z"
                        />
                      </svg>
                    </a>
                  </div>
                  <ul
                    class="flex justify-end gap-x-4 w-full  items-center   md:text-base m-0  text-lg"
                  >
                    <li
                      class="flex  items-center gap-x-1  md:text-base m-0 font-roboto font-semibold"
                    >
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.5526 15.4488C18.4374 15.9649 18.152 16.4272 17.7422 16.7615C17.2945 17.2155 16.7611 17.5761 16.1729 17.8222C15.5846 18.0683 14.9534 18.1951 14.3157 18.1951H14.0178C12.6795 18.1225 11.3691 17.7837 10.1632 17.1987H10.1541C9.87448 17.0685 9.58573 16.9384 9.30614 16.7798C7.89852 15.9905 6.60742 15.0095 5.46989 13.8648C3.99366 12.4782 2.78223 10.8344 1.89489 9.0138C1.42331 8.01605 1.10855 6.95149 0.961727 5.85771C0.745817 4.7128 0.875696 3.52953 1.33481 2.45871C1.62466 1.97561 1.97866 1.53404 2.38714 1.14605C2.57095 0.938192 2.79567 0.770503 3.04724 0.653468C3.29882 0.536434 3.57184 0.472573 3.84923 0.465881C4.1509 0.49922 4.44295 0.592152 4.70842 0.739284C4.97389 0.886416 5.20748 1.08482 5.39564 1.32296C5.81456 1.77855 6.32606 2.25338 6.74589 2.69155L7.32339 3.25988C7.66256 3.56055 7.87248 3.98038 7.91006 4.43321C7.91006 4.84846 7.75698 5.24905 7.48106 5.5598C7.30237 5.77713 7.11268 5.98518 6.91273 6.18313L6.72664 6.37838C6.61848 6.47921 6.53598 6.60388 6.48464 6.7423C6.43881 6.87857 6.42048 7.01821 6.42964 7.16121C6.57723 7.5563 6.80914 7.91563 7.10798 8.21355C7.57456 8.84605 8.04023 9.39605 8.51506 9.99188C9.37393 10.989 10.3932 11.8357 11.5309 12.4971C11.6473 12.5824 11.7811 12.6392 11.9232 12.664C12.0461 12.6731 12.1707 12.6548 12.2862 12.609C12.6116 12.4174 12.9004 12.1717 13.1424 11.882C13.4678 11.4835 13.935 11.2266 14.4459 11.1652C14.9375 11.172 15.4064 11.373 15.7503 11.7244C15.9364 11.882 16.1408 12.0965 16.337 12.3019L16.6156 12.5897L16.9044 12.8693L17.3985 13.3716C17.693 13.6332 17.9693 13.9128 18.2271 14.2104C18.4856 14.5679 18.6021 15.0106 18.5526 15.4488ZM15.2104 9.06971C15.0257 9.0678 14.8492 8.9936 14.7186 8.86302C14.588 8.73243 14.5138 8.55588 14.5119 8.37121C14.5129 7.84393 14.4097 7.32163 14.2084 6.8343C14.007 6.34696 13.7115 5.90417 13.3386 5.53132C12.9658 5.15847 12.523 4.8629 12.0356 4.66156C11.5483 4.46023 11.026 4.35708 10.4987 4.35805C10.3135 4.35805 10.1358 4.28446 10.0048 4.15346C9.87382 4.02247 9.80023 3.8448 9.80023 3.65955C9.80023 3.47429 9.87382 3.29663 10.0048 3.16563C10.1358 3.03464 10.3135 2.96105 10.4987 2.96105C11.2095 2.95996 11.9135 3.09916 12.5704 3.37066C13.2273 3.64216 13.8241 4.04063 14.3267 4.54323C14.8293 5.04582 15.2278 5.64267 15.4993 6.29955C15.7708 6.95643 15.91 7.66044 15.9089 8.37121C15.9091 8.46301 15.8912 8.55395 15.8562 8.6388C15.8212 8.72366 15.7698 8.80076 15.7048 8.86567C15.6399 8.93058 15.5628 8.98202 15.478 9.01704C15.3931 9.05205 15.3022 9.06995 15.2104 9.06971Z"
                          fill="#FA6914"
                        />
                      </svg>
                      <a
                        href="tel:+977-015971231"
                        class="text-[#0083D7] font-roboto font-semibold"
                        >015971231</a
                      >
                    </li>
                    <li
                      class="flex items-center gap-x-1 text-sm md:text-base m-0 "
                    >
                      <svg
                        width="21"
                        height="17"
                        viewBox="0 0 21 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.92182 16.7916C2.3704 16.7916 1.89851 16.5954 1.50615 16.2031C1.1138 15.8107 0.917294 15.3385 0.916626 14.7864V2.7552C0.916626 2.20377 1.11314 1.73188 1.50615 1.33953C1.89917 0.947178 2.37106 0.750668 2.92182 0.75H18.9634C19.5148 0.75 19.9871 0.946509 20.3801 1.33953C20.7731 1.73255 20.9693 2.20444 20.9686 2.7552V14.7864C20.9686 15.3378 20.7724 15.8101 20.3801 16.2031C19.9877 16.5961 19.5155 16.7923 18.9634 16.7916H2.92182ZM10.9426 9.59794C11.0262 9.59794 11.1141 9.58524 11.2063 9.55984C11.2985 9.53444 11.3861 9.49701 11.469 9.44755L18.5624 5.01105C18.6961 4.9275 18.7963 4.82323 18.8632 4.69824C18.93 4.57325 18.9634 4.43522 18.9634 4.28416C18.9634 3.94996 18.8214 3.69931 18.5373 3.53221C18.2532 3.36511 17.9608 3.37347 17.66 3.55728L10.9426 7.7682L4.2252 3.55728C3.92442 3.37347 3.632 3.36946 3.34793 3.54525C3.06386 3.72104 2.92182 3.96734 2.92182 4.28416C2.92182 4.45126 2.95524 4.59764 3.02208 4.7233C3.08892 4.84896 3.18918 4.94488 3.32286 5.01105L10.4163 9.44755C10.4998 9.49768 10.5877 9.53545 10.6799 9.56085C10.7722 9.58625 10.8597 9.59861 10.9426 9.59794Z"
                          fill="#FA6914"
                        />
                      </svg>
                      <a
                        class="text-[#0083D7] font-semibold font-roboto"
                        href="mailto:reliablecargopvt.ltd@gmail.com"
                        >reliablecargopvt.ltd@gmail.com</a
                      >
                    </li>
                    <li class="flex items-center md:text-base   m-0   ">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.0001 1.83368C14.0342 1.83368 16.5001 4.27201 16.5001 7.28785C16.5001 11.3762 11.0001 17.417 11.0001 17.417C11.0001 17.417 5.50008 11.3762 5.50008 7.28785C5.50008 4.27201 7.96591 1.83368 11.0001 1.83368ZM11.0001 5.50035C10.5139 5.50035 10.0475 5.6935 9.70372 6.03732C9.3599 6.38113 9.16675 6.84745 9.16675 7.33368C9.16675 7.81991 9.3599 8.28622 9.70372 8.63004C10.0475 8.97386 10.5139 9.16701 11.0001 9.16701C11.4863 9.16701 11.9526 8.97386 12.2964 8.63004C12.6403 8.28622 12.8334 7.81991 12.8334 7.33368C12.8334 6.84745 12.6403 6.38113 12.2964 6.03732C11.9526 5.6935 11.4863 5.50035 11.0001 5.50035ZM18.3334 17.417C18.3334 19.4428 15.0517 21.0837 11.0001 21.0837C6.94841 21.0837 3.66675 19.4428 3.66675 17.417C3.66675 16.2345 4.78508 15.1803 6.51758 14.5112L7.10425 15.3453C6.11425 15.7578 5.50008 16.3262 5.50008 16.9587C5.50008 18.2237 7.96591 19.2503 11.0001 19.2503C14.0342 19.2503 16.5001 18.2237 16.5001 16.9587C16.5001 16.3262 15.8859 15.7578 14.8959 15.3453L15.4826 14.5112C17.2151 15.1803 18.3334 16.2345 18.3334 17.417Z"
                          fill="#FA6914"
                        />
                      </svg>
                      <span
                        class="text-[#0083D7] font-roboto font-semibold whitespace-nowrap"
                        >Paknajol Marg 16,Thamel,KTM</span
                      >
                    </li>
                    <li class="flex items-center md:text-base   gap-x-2  ">
                      <svg
                        width="22px"
                        height="22px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M13 2C10.2386 2 8 4.23858 8 7C8 7.55228 8.44772 8 9 8C9.55228 8 10 7.55228 10 7C10 5.34315 11.3431 4 13 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H13C11.3431 20 10 18.6569 10 17C10 16.4477 9.55228 16 9 16C8.44772 16 8 16.4477 8 17C8 19.7614 10.2386 22 13 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H13Z"
                            fill="#FA6914"
                          ></path>
                          <path
                            d="M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H11.2821C11.1931 13.1098 11.1078 13.2163 11.0271 13.318C10.7816 13.6277 10.5738 13.8996 10.427 14.0945C10.3536 14.1921 10.2952 14.2705 10.255 14.3251L10.2084 14.3884L10.1959 14.4055L10.1915 14.4115C10.1914 14.4116 10.191 14.4122 11 15L10.1915 14.4115C9.86687 14.8583 9.96541 15.4844 10.4122 15.809C10.859 16.1336 11.4843 16.0346 11.809 15.5879L11.8118 15.584L11.822 15.57L11.8638 15.5132C11.9007 15.4632 11.9553 15.3897 12.0247 15.2975C12.1637 15.113 12.3612 14.8546 12.5942 14.5606C13.0655 13.9663 13.6623 13.2519 14.2071 12.7071L14.9142 12L14.2071 11.2929C13.6623 10.7481 13.0655 10.0337 12.5942 9.43937C12.3612 9.14542 12.1637 8.88702 12.0247 8.7025C11.9553 8.61033 11.9007 8.53682 11.8638 8.48679L11.822 8.43002L11.8118 8.41602L11.8095 8.41281C11.4848 7.96606 10.859 7.86637 10.4122 8.19098C9.96541 8.51561 9.86636 9.14098 10.191 9.58778L11 9C10.191 9.58778 10.1909 9.58773 10.191 9.58778L10.1925 9.58985L10.1959 9.59454L10.2084 9.61162L10.255 9.67492C10.2952 9.72946 10.3536 9.80795 10.427 9.90549C10.5738 10.1004 10.7816 10.3723 11.0271 10.682C11.1078 10.7837 11.1931 10.8902 11.2821 11H3Z"
                            fill="#FA6914"
                          ></path>
                        </g>
                      </svg>
                      <a
                        href="https://app.reliablecargo.com.np"
                        target="_blank"
                        class="text-[#0083D7] font-roboto font-semibold"
                        >Login</a
                      >
                      <span class="text-[#0083D7]">|</span>
                      <a
                        href="/signup"
                        class="text-[#0083D7] font-roboto font-semibold"
                        >Signup</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="container mx-auto px-4 md:px-12 flex items-center justify-between"
            >
              <div class="flex items-center justify-between w-full md:w-fit">
                <a href="/" class="p-2">
                  <img
                    src="https://via.placeholder.com/100"
                    alt="Logo"
                    class="md:w-20 h-14 w-16 md:h-20 cursor-pointer object-contain"
                  />
                </a>
                <button id="menu-toggle" class="md:hidden p-2 ">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M17.2918 6.33326C17.2918 6.49902 17.2259 6.658 17.1087 6.77521C16.9915 6.89242 16.8325 6.95827 16.6668 6.95827H3.33326C3.1675 6.95827 3.00852 6.89242 2.89131 6.77521C2.7741 6.658 2.70825 6.49902 2.70825 6.33326C2.70825 6.1675 2.7741 6.00852 2.89131 5.89131C3.00852 5.7741 3.1675 5.70825 3.33326 5.70825H16.6668C16.8325 5.70825 16.9915 5.7741 17.1087 5.89131C17.2259 6.00852 17.2918 6.1675 17.2918 6.33326ZM17.2918 10.5C17.2918 10.6657 17.2259 10.8247 17.1087 10.9419C16.9915 11.0591 16.8325 11.125 16.6668 11.125H3.33326C3.1675 11.125 3.00852 11.0591 2.89131 10.9419C2.7741 10.8247 2.70825 10.6657 2.70825 10.5C2.70825 10.3342 2.7741 10.1753 2.89131 10.058C3.00852 9.94083 3.1675 9.87498 3.33326 9.87498H16.6668C16.8325 9.87498 16.9915 9.94083 17.1087 10.058C17.2259 10.1753 17.2918 10.3342 17.2918 10.5ZM17.2918 14.6667C17.2918 14.8325 17.2259 14.9914 17.1087 15.1087C16.9915 15.2259 16.8325 15.2917 16.6668 15.2917H3.33326C3.1675 15.2917 3.00852 15.2259 2.89131 15.1087C2.7741 14.9914 2.70825 14.8325 2.70825 14.6667C2.70825 14.5009 2.7741 14.342 2.89131 14.2248C3.00852 14.1076 3.1675 14.0417 3.33326 14.0417H16.6668C16.8325 14.0417 16.9915 14.1076 17.1087 14.2248C17.2259 14.342 17.2918 14.5009 17.2918 14.6667Z"
                      fill="#272727"
                    />
                  </svg>
                </button>
              </div>
              <div class="hidden md:flex space-x-6 items-center text-lg">
                <a href="/" class=" font-semibold hover:text-[#FA6914]">Home</a>
                <div class="relative group dropdown-container">
                  <a
                    href="/services"
                    class="font-semibold hover:text-[#FA6914] flex items-center gap-1"
                  >
                    Services
                    <svg
                      class="w-3 h-3 transform transition-transform duration-300 group-[.open]:rotate-180"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </a>
                  <div
                    class="dropdown-menu absolute left-0 mt-2 w-60 bg-white  rounded-md shadow-lg opacity-0 invisible transition-all duration-300 ease-in-out transform scale-y-95 origin-top z-50"
                  >
                    <ul class="py-2 text-sm text-[#0083D7] font-bold">
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/air-transport">Air Transport</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/ocean-transport">Ocean Transport</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/train-transport">Train Transport</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/road-transport">Road Transport</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/home-delivery">Home Delivery</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/packaging">Packaging</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/door-to-door-cargo">Door to Door Cargo</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/warehousing">Warehousing</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/custom-clearing">Custom Clearing</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/pickup-and-drop">Pickup and Drop</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/documentation">Documentation</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/cargo-and-courier">Cargo and Courier</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/project-cargo">Project Cargo</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="relative group dropdown-container">
                  <a
                    href="/aboutus"
                    class="font-semibold flex items-center hover:text-[#FA6914] gap-1"
                  >
                    About Us
                    <svg
                      class="w-3 h-3 transform transition-transform duration-300 group-[.open]:rotate-180"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </a>
                  <div
                    class="dropdown-menu absolute left-0 mt-2 w-60 bg-white  rounded-md shadow-lg opacity-0 invisible transition-all duration-300 ease-in-out transform scale-y-95 origin-top z-50"
                  >
                    <ul class="py-2 text-sm text-[#0083D7] font-bold">
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/aboutus">About </a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/services"> Service</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/team"> Team </a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/quote">Get A Quote</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/faqs"> FAQ </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <a href="/blog-list" class=" font-semibold hover:text-[#FA6914]"
                  >Blog</a
                >
                <a href="/contact" class=" font-semibold hover:text-[#FA6914]"
                  >Contact</a
                >
              </div>
              <div class="hidden md:flex items-center space-x-4">
                <a
                  href="/track"
                  class="px-6 py-2 bg-[#FA6914] text-lg text-white rounded-md shadow"
                >
                  Track Now
                </a>
              </div>
              <div
                id="mobile-menu"
                class="fixed inset-0 z-20 bg-white w-full h-full shadow-lg transform -translate-x-full transition-transform md:hidden"
              >
                <div class="p-4">
                  <div class="flex items-center justify-between ">
                    <img
                      id="navbarLogo"
                      src=""
                      alt="Logo"
                      class="w-20 h-16 md:h-20 cursor-pointer object-contain"
                    />
                    <button id="close-menu" class="p-2 ">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 6L6 18M6 6L18 18"
                          stroke="#0D0D0D"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                  <div class="mt-4  mobile-nav-links">
                    <ul
                      class="py-2 flex flex-col space-y-3 text-sm text-[#0083D7] font-bold"
                    >
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/">Home </a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/services"> Service</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/blog-list"> Blog </a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/aboutus">About Us</a>
                      </li>
                      <li
                        class="px-4 py-2 hover:bg-gray-100 hover:text-[#FA6914]"
                      >
                        <a href="/contact"> Contact </a>
                      </li>
                    </ul>
                    <hr />
                    <a href="/track" class="text-[#FA6914] px-4 py-4">
                      Track Now
                    </a>
                    <hr />
                    <ul class="flex flex-col mt-2 gap-y-3  w-full">
                      <li
                        class="flex  items-center text-gray-300 gap-x-1 text-sm m-0 font-roboto font-semibold"
                      >
                        <svg
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.5526 15.4488C18.4374 15.9649 18.152 16.4272 17.7422 16.7615C17.2945 17.2155 16.7611 17.5761 16.1729 17.8222C15.5846 18.0683 14.9534 18.1951 14.3157 18.1951H14.0178C12.6795 18.1225 11.3691 17.7837 10.1632 17.1987H10.1541C9.87448 17.0685 9.58573 16.9384 9.30614 16.7798C7.89852 15.9905 6.60742 15.0095 5.46989 13.8648C3.99366 12.4782 2.78223 10.8344 1.89489 9.0138C1.42331 8.01605 1.10855 6.95149 0.961727 5.85771C0.745817 4.7128 0.875696 3.52953 1.33481 2.45871C1.62466 1.97561 1.97866 1.53404 2.38714 1.14605C2.57095 0.938192 2.79567 0.770503 3.04724 0.653468C3.29882 0.536434 3.57184 0.472573 3.84923 0.465881C4.1509 0.49922 4.44295 0.592152 4.70842 0.739284C4.97389 0.886416 5.20748 1.08482 5.39564 1.32296C5.81456 1.77855 6.32606 2.25338 6.74589 2.69155L7.32339 3.25988C7.66256 3.56055 7.87248 3.98038 7.91006 4.43321C7.91006 4.84846 7.75698 5.24905 7.48106 5.5598C7.30237 5.77713 7.11268 5.98518 6.91273 6.18313L6.72664 6.37838C6.61848 6.47921 6.53598 6.60388 6.48464 6.7423C6.43881 6.87857 6.42048 7.01821 6.42964 7.16121C6.57723 7.5563 6.80914 7.91563 7.10798 8.21355C7.57456 8.84605 8.04023 9.39605 8.51506 9.99188C9.37393 10.989 10.3932 11.8357 11.5309 12.4971C11.6473 12.5824 11.7811 12.6392 11.9232 12.664C12.0461 12.6731 12.1707 12.6548 12.2862 12.609C12.6116 12.4174 12.9004 12.1717 13.1424 11.882C13.4678 11.4835 13.935 11.2266 14.4459 11.1652C14.9375 11.172 15.4064 11.373 15.7503 11.7244C15.9364 11.882 16.1408 12.0965 16.337 12.3019L16.6156 12.5897L16.9044 12.8693L17.3985 13.3716C17.693 13.6332 17.9693 13.9128 18.2271 14.2104C18.4856 14.5679 18.6021 15.0106 18.5526 15.4488ZM15.2104 9.06971C15.0257 9.0678 14.8492 8.9936 14.7186 8.86302C14.588 8.73243 14.5138 8.55588 14.5119 8.37121C14.5129 7.84393 14.4097 7.32163 14.2084 6.8343C14.007 6.34696 13.7115 5.90417 13.3386 5.53132C12.9658 5.15847 12.523 4.8629 12.0356 4.66156C11.5483 4.46023 11.026 4.35708 10.4987 4.35805C10.3135 4.35805 10.1358 4.28446 10.0048 4.15346C9.87382 4.02247 9.80023 3.8448 9.80023 3.65955C9.80023 3.47429 9.87382 3.29663 10.0048 3.16563C10.1358 3.03464 10.3135 2.96105 10.4987 2.96105C11.2095 2.95996 11.9135 3.09916 12.5704 3.37066C13.2273 3.64216 13.8241 4.04063 14.3267 4.54323C14.8293 5.04582 15.2278 5.64267 15.4993 6.29955C15.7708 6.95643 15.91 7.66044 15.9089 8.37121C15.9091 8.46301 15.8912 8.55395 15.8562 8.6388C15.8212 8.72366 15.7698 8.80076 15.7048 8.86567C15.6399 8.93058 15.5628 8.98202 15.478 9.01704C15.3931 9.05205 15.3022 9.06995 15.2104 9.06971Z"
                            fill="#FA6914"
                          />
                        </svg>
                        <a
                          href="tel:+977-015971231"
                          class="text-[#0083D7] font-roboto font-semibold"
                          >+977-015971231</a
                        >
                      </li>
                      <li
                        class="flex items-center gap-x-1 text-sm md:text-base m-0 "
                      >
                        <svg
                          width="21"
                          height="17"
                          viewBox="0 0 21 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.92182 16.7916C2.3704 16.7916 1.89851 16.5954 1.50615 16.2031C1.1138 15.8107 0.917294 15.3385 0.916626 14.7864V2.7552C0.916626 2.20377 1.11314 1.73188 1.50615 1.33953C1.89917 0.947178 2.37106 0.750668 2.92182 0.75H18.9634C19.5148 0.75 19.9871 0.946509 20.3801 1.33953C20.7731 1.73255 20.9693 2.20444 20.9686 2.7552V14.7864C20.9686 15.3378 20.7724 15.8101 20.3801 16.2031C19.9877 16.5961 19.5155 16.7923 18.9634 16.7916H2.92182ZM10.9426 9.59794C11.0262 9.59794 11.1141 9.58524 11.2063 9.55984C11.2985 9.53444 11.3861 9.49701 11.469 9.44755L18.5624 5.01105C18.6961 4.9275 18.7963 4.82323 18.8632 4.69824C18.93 4.57325 18.9634 4.43522 18.9634 4.28416C18.9634 3.94996 18.8214 3.69931 18.5373 3.53221C18.2532 3.36511 17.9608 3.37347 17.66 3.55728L10.9426 7.7682L4.2252 3.55728C3.92442 3.37347 3.632 3.36946 3.34793 3.54525C3.06386 3.72104 2.92182 3.96734 2.92182 4.28416C2.92182 4.45126 2.95524 4.59764 3.02208 4.7233C3.08892 4.84896 3.18918 4.94488 3.32286 5.01105L10.4163 9.44755C10.4998 9.49768 10.5877 9.53545 10.6799 9.56085C10.7722 9.58625 10.8597 9.59861 10.9426 9.59794Z"
                            fill="#FA6914"
                          />
                        </svg>
                        <a
                          class="text-[#0083D7] font-semibold font-roboto"
                          href="mailto:reliablecargopvt.ltd@gmail.com"
                          >reliablecargopvt.ltd@gmail.com</a
                        >
                      </li>
                      <li class="flex items-center text-sm  ">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.0001 1.83368C14.0342 1.83368 16.5001 4.27201 16.5001 7.28785C16.5001 11.3762 11.0001 17.417 11.0001 17.417C11.0001 17.417 5.50008 11.3762 5.50008 7.28785C5.50008 4.27201 7.96591 1.83368 11.0001 1.83368ZM11.0001 5.50035C10.5139 5.50035 10.0475 5.6935 9.70372 6.03732C9.3599 6.38113 9.16675 6.84745 9.16675 7.33368C9.16675 7.81991 9.3599 8.28622 9.70372 8.63004C10.0475 8.97386 10.5139 9.16701 11.0001 9.16701C11.4863 9.16701 11.9526 8.97386 12.2964 8.63004C12.6403 8.28622 12.8334 7.81991 12.8334 7.33368C12.8334 6.84745 12.6403 6.38113 12.2964 6.03732C11.9526 5.6935 11.4863 5.50035 11.0001 5.50035ZM18.3334 17.417C18.3334 19.4428 15.0517 21.0837 11.0001 21.0837C6.94841 21.0837 3.66675 19.4428 3.66675 17.417C3.66675 16.2345 4.78508 15.1803 6.51758 14.5112L7.10425 15.3453C6.11425 15.7578 5.50008 16.3262 5.50008 16.9587C5.50008 18.2237 7.96591 19.2503 11.0001 19.2503C14.0342 19.2503 16.5001 18.2237 16.5001 16.9587C16.5001 16.3262 15.8859 15.7578 14.8959 15.3453L15.4826 14.5112C17.2151 15.1803 18.3334 16.2345 18.3334 17.417Z"
                            fill="#FA6914"
                          />
                        </svg>
                        <span class="text-[#0083D7] font-roboto font-semibold"
                          >Paknajol Marg 16,Thamel,Kathmandu</span
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        `,
        script: function () {
          const mobileToggle = document.getElementById(
            "menu-toggle"
          ) as HTMLButtonElement;
          const mobileMenu = document.getElementById("mobile-menu");

          mobileToggle.addEventListener("click", function () {
            mobileMenu.classList.remove("-translate-x-full");
          });

          document
            .getElementById("close-menu")
            .addEventListener("click", function () {
              document
                .getElementById("mobile-menu")
                .classList.add("-translate-x-full");
            });
          document
            .querySelectorAll("#mobile-menu .nav-link")
            .forEach((link) => {
              link.addEventListener("click", function () {
                document
                  .getElementById("mobile-menu")
                  .classList.add("-translate-x-full");
              });
            });
          document
            .querySelectorAll(".dropdown-container")
            .forEach((container) => {
              const dropdown = container.querySelector(".dropdown-menu");
              let timeoutId: number;

              container.addEventListener("mouseenter", () => {
                clearTimeout(timeoutId);
                dropdown.classList.add("opacity-100", "visible", "scale-y-100");
                dropdown.classList.remove(
                  "opacity-0",
                  "invisible",
                  "scale-y-95"
                );
                container.classList.add("open");
              });

              container.addEventListener("mouseleave", () => {
                timeoutId = window.setTimeout(() => {
                  dropdown.classList.remove(
                    "opacity-100",
                    "visible",
                    "scale-y-100"
                  );
                  dropdown.classList.add(
                    "opacity-0",
                    "invisible",
                    "scale-y-95"
                  );
                  container.classList.remove("open");
                }, 200); // 200ms delay
              });
            });
        },

        toolbar: [
          {
            attributes: { class: "fa fa-trash-o" },
            command: "tlb-delete",
          },
          {
            attributes: { class: "fa fa-gear" },
            command: "navbar-edit",
          },
        ],
      },
    },
  });
};
